<template>
	<div v-if="aiAsqShow">
		<div class="fadein_bind ASQ">
			<div class="box" style="width: 600px;">
				<div class="head">
					<p>{{$t('aipf')}}</p>
					<img src="@/assets/images/close_03.png" @click="back" class="close" />
				</div>
				<div class="airank">
					<div class="item">
						<p>{{$t('bencily')}}</p>
						<audio :src="aiData.audioUrl" controls="controls"></audio>
					</div>
					<div class="item">
						<p>{{$t('bencipf')}}</p>
						<div class="jds">
							<div class="icon">
								<span>{{$t('neirong')}}</span>
								<img src="@/assets/images/whs_03.png" />
							</div>
							<div class="jd">
								<div :style="`width: ${aiData.score/aiData.totalScore*100}%`"></div>
							</div>
							<span>{{$t('zhengque')}}<em>{{aiData.score}}/{{aiData.totalScore}}</em></span>
						</div>
					</div>
					<div class="button">
						<div class="on" @click="back">{{$t('back')}}</div>
						<div @click="back">{{$t('queding')}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import protal from "@/api/protal";
	import { Message } from 'element-ui';
	import { Loading } from 'element-ui';
	export default {
		name: 'aiAsqShow',
		props: ['aiData'],
		data() {
			return {

			}
		},
		computed: {
			aiAsqShow() {
				return this.$store.state.aiAsqShow;
			}
		},
		methods: {
			back() {
				this.$store.commit("showaiAsqShow", false);
			},
		},
	}
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/components/ai-ASQ.vue